import { render, staticRenderFns } from "./detailRelevancyEvent.vue?vue&type=template&id=610ba974&scoped=true&"
import script from "./detailRelevancyEvent.vue?vue&type=script&lang=js&"
export * from "./detailRelevancyEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610ba974",
  null
  
)

export default component.exports